<template>
  <div class="backWrapper">
    <a-spin :spinning="loading" tip="加载中">
      <h3>补充背调资料</h3>
      <div class="title">
        我们会对您的信息进行严格保密，郑重承诺绝不会将您的信息泄露给其他任何机构和个人。请认真核对您的信息，并提供准确的资料。如有问题，请联系HR协助处理。
      </div>
      <a-form :form="form">
        <a-form-item label="委托公司">
          <a-input disabled value="北京猿力教育科技有限公司"> </a-input>
        </a-form-item>
        <a-form-item label="候选人姓名">
          <a-input disabled v-decorator="['name']"> </a-input>
        </a-form-item>
        <a-form-item label="手机号码">
          <a-input disabled v-decorator="['phone']"> </a-input>
        </a-form-item>
        <a-form-item label="身份证号码">
          <a-input disabled v-decorator="['idCard']"> </a-input>
        </a-form-item>
        <a-form-item
          label="学历证书照片"
          required
          v-if="
            mealFieldMap[mealType] &&
              mealFieldMap[mealType].includes('educationalBackground')
          "
          extra="请上传清晰可见且包含证书编号的学历、学位证书照片"
        >
          <UploadHandly
            v-decorator="[
              'educationalBackground',
              {
                validateTrigger: 'onChange',
                trigger: 'onChange',
                rules: [{ validator: validateFile }],
              },
            ]"
            :fileList="[]"
          ></UploadHandly>
        </a-form-item>
        <a-form-item
          label="学位证书照片"
          required
          v-if="
            mealFieldMap[mealType] && mealFieldMap[mealType].includes('degree')
          "
          extra="请上传清晰可见且包含证书编号的学历、学位证书照片"
        >
          <UploadHandly
            v-decorator="[
              'degree',
              {
                validateTrigger: 'onChange',
                trigger: 'onChange',
                rules: [{ validator: validateFile }],
              },
            ]"
            :fileList="[]"
          ></UploadHandly>
        </a-form-item>
        <a-form-item
          label="学籍认证报告"
          required
          v-if="
            mealFieldMap[mealType] &&
              mealFieldMap[mealType].includes('academicReport')
          "
        >
          <template slot="extra">
            请注册并登录学信网，获得学籍认证报告，
            <a
              @click="reportGuide"
              href="javascript:void(0)"
              style="color: #ff6c00"
              >点击查看操作步骤</a
            >
          </template>
          <UploadHandly
            v-decorator="[
              'academicReport',
              {
                validateTrigger: 'onChange',
                trigger: 'onChange',
                rules: [{ validator: validateFile }],
              },
            ]"
            :fileList="[]"
          ></UploadHandly>
        </a-form-item>
      </a-form>
      <a-button class="submit" @click="submit">提交背调信息</a-button>
    </a-spin>
  </div>
</template>
<script>
import { UploadHandly } from '@/components/Upload'
import { mealFieldMap } from './mealFieldMap'
import { getCandidateInfo, saveBackInfo } from '@/service/backCheck.js'
import { Toast } from 'vant'
export default {
  components: { UploadHandly },
  data: function() {
    return {
      form: this.$form.createForm(this),
      mealFieldMap,
      mealType: '',
      authCode: this.$route.query.authCode,
      loading: true,
    }
  },
  created() {
    getCandidateInfo(this.authCode)
      .then(res => {
        this.loading = false
        this.mealType = res.setMealType
        // 回填信息
        const { name, phone, idCard } = res
        this.$nextTick(() => {
          this.form.setFieldsValue({ name, phone, idCard })
        })
      })
      .catch(() => {
        this.loading = false
      })
  },
  methods: {
    async submit() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.loading = true
          const formData = this.getFormData(values)
          saveBackInfo(this.authCode, formData).then(res => {
            this.loading = false
            if (res.code == -1) {
              Toast.fail({ duration: 5000, message: res.data })
              this.loading = false
            } else {
              Toast.success('提交成功')
              this.$router.push({
                name: 'backCheckSuccess',
              })
            }
          })
        }
      })
    },
    getFormData(values) {
      let formData = new FormData()
      ;['name', 'phone', 'idCard'].forEach(key => {
        formData.append(key, values[key])
      })
      mealFieldMap[this.mealType].forEach(key => {
        formData.append(key, values[key][0])
      })
      formData.append('setMealType', this.mealType)

      return formData
    },

    validateFile(rule, value, callback) {
      if (!value || value.length == 0) {
        callback('请上传文件')
      } else if (value.length > 1) {
        callback('仅可上传一个文件')
      } else {
        // 检测文件大小
        const file = value[0]
        if (file.size > 5 * 1024 * 1024) {
          callback('请上传小于5M的文件')
        } else {
          callback()
        }
      }
    },
    reportGuide() {
      // let routeData = this.$router.resolve({
      //   name: 'backCheckGuide',
      // })
      // window.open(routeData.href, '_blank')
      window.open('https://www.chsi.com.cn/xlcx/rhsq.jsp', '_blank')
    },
  },
}
</script>
<style lang="less">
@import '~@style/common.less';
.backWrapper {
  margin: 0 auto;
  padding: 15px 15px 48px;
  max-width: 750px;
  height: 100vh;
  overflow: auto;
  .title {
    margin-bottom: 20px;
  }
  .submit {
    width: 100%;
    height: 48px;
    font-size: 18px;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0;
    background: @tutor-color;
    color: #fff;
    &:hover,
    &:focus {
      border: none;
    }
  }
  /deep/ .ant-form {
    .ant-form-item {
      .ant-form-item-label {
        color: #333;
        font-size: 14px;
        line-height: 16px;
        padding-bottom: 16px;
      }
    }
    .ant-form-item-required::before {
      color: @tutor-color;
    }
    .ant-select-selection,
    .ant-input {
      border-radius: 0;
    }
    .ant-select-selection--single,
    .ant-input {
      height: 36px;
    }
    .ant-select-selection__rendered,
    .ant-input {
      line-height: 34px;
    }
    .has-error .ant-input,
    .has-error .ant-input:hover,
    .has-error .ant-select-selection {
      border-color: @tutor-color;
    }
    .has-error .ant-form-explain,
    .has-error .ant-form-split {
      color: @tutor-color;
    }
  }
  .ant-upload-list {
    display: block;
  }
}
</style>
